<div [formGroup]="form">
    <div class="flex-row-generic">
        <!-- Preferred Laboratories start -->
        <div class="form-group flex-item-two-columns">
            <label for="{{ baseId }}-preferred-laboratories-findcontrol">Preferred Laboratories</label>
            <ap-findcontrol [baseId]="baseId" [form]="form" [apFormGroup]="form" [formGroupSubmitted]="isSubmitted"
                [required]="getFindControlValidation('PreferredLaboratoriesUid')"
                [findControlId]="findControlIdService.ListLaboratory" [singleSelect]="false"
                [(selectedPks)]="selectedPreferredLaboratoriesPks" id="{{ baseId }}-preferred-laboratories-findcontrol"
                baseId="{{ baseId }}-preferred-laboratories-findcontrol" controlName="preferredLaboratoriesUid"
                findControlDisplayName="Find Laboratory" (dirty)="preferredLaboratoriesUidControl.markAsDirty()">
            </ap-findcontrol>
        </div>
        <!-- Preferred Laboratories Control end -->

        <!-- Payment Typology Control start -->
        <div class="form-group flex-item-two-columns">
            <label for="{{ baseId }}-payment-typology-findcontrol">Payment Typology</label>
            <ap-findcontrol [baseId]="baseId" [form]="form" [apFormGroup]="form" [formGroupSubmitted]="isSubmitted"
                [required]="getFindControlValidation('PayerTypologySourceUid')"
                [findControlId]="findControlIdService.ListPayerTypologySource" [singleSelect]="true"
                [(selectedPks)]="selectedPaymentTypologyPks"
                id="{{ baseId }}-payment-typology-findcontrol" baseId="{{ baseId }}-payment-typology-findcontrol"
                controlName="paymentTypologyUid" findControlDisplayName="Find Payer Typology Source"
                (dirty)="paymentTypologyUidControl.markAsDirty()">
            </ap-findcontrol>
        </div>
        <!-- Payment Typology Control end -->
    </div>
</div>
